module.exports = __webpack_public_path__ + "img/new_infrastructure.6fd8c399.svg";